module.exports = __webpack_public_path__ + "img/ic_upload_fail.2cb6ebb4.svg";